<template>
	<div>
		<v-card
      v-if="mostrarAvisoGruposBloqueados"
      class="encuesta-teaser-card encuesta-teaser-card--warning mb-4"
      flat
      rounded="xl"
      role="article"
      aria-labelledby="encuesta-grupos-title"
    >
      <div class="encuesta-teaser-inner">
        <div class="encuesta-teaser-icon-wrap encuesta-teaser-icon-wrap--warning" aria-hidden="true">
          <v-icon class="encuesta-teaser-icon--warning" size="36">
            mdi-account-group-outline
          </v-icon>
        </div>
        <div class="encuesta-teaser-copy">
          <span class="encuesta-teaser-overline encuesta-teaser-overline--warning text-overline letter-spacing-1">Mis grupos</span>
          <h3 id="encuesta-grupos-title" class="encuesta-teaser-title encuesta-teaser-title--warning text-h6 font-weight-bold mb-0">
            Tu opinión nos ayuda a mejorar 💙<br>
            Responde la encuesta para acceder a tus grupos.
          </h3>
        </div>
      </div>
    </v-card>

		<v-card
      class="encuesta-teaser-card"
      flat
      rounded="xl"
      role="article"
      aria-labelledby="encuesta-teaser-title"
    >
      <div class="encuesta-teaser-inner">
        <div class="encuesta-teaser-icon-wrap" aria-hidden="true">
          <v-icon color="primary" size="36">
            mdi-clipboard-text-outline
          </v-icon>
        </div>
        <div class="encuesta-teaser-copy">
          <span class="encuesta-teaser-overline text-overline letter-spacing-1">Tu opinión cuenta</span>
          <h3 id="encuesta-teaser-title" class="encuesta-teaser-title text-h6 font-weight-bold mb-2 primary--text">
            Encuesta de satisfacción
          </h3>
          <p class="encuesta-teaser-desc text-body-2" :class="(encuestaSatis && encuestaSatis.sinGrupo) ? 'mb-2' : 'mb-4'">
            Ayúdanos a mejorar: solo te tomará unos minutos y tus respuestas son confidenciales.
          </p>
          <p
            v-if="encuestaSatis && encuestaSatis.sinGrupo"
            class="encuesta-teaser-sin-grupo text-caption warning--text font-weight-medium mb-4"
          >
            Aún no tienes grupo asignado: puedes revisar la encuesta, pero podrás enviarla cuando aparezca en «Mis grupos».
          </p>
          <v-btn
            color="primary"
            depressed
            large
            rounded
            block
            class="encuesta-teaser-cta text-none font-weight-bold elevation-2"
            aria-label="Abrir encuesta de satisfacción"
            @click="abrirEncuesta"
          >
            Contestar encuesta
            <v-icon right size="20">mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>

		<v-dialog
      v-model="dialogEncuesta"
      persistent
      fullscreen
      scrollable
      transition="dialog-bottom-transition"
    >
    	<v-card class="encuesta-satis-dialog d-flex flex-column" style="min-height: 100%;">
		    <v-card-text class="encuesta-dialog-body flex-grow-1 pt-5 pb-2 px-4">
		      <div class="d-flex justify-space-between align-center mb-4 flex-wrap" style="gap: 8px;">
		        <div class="d-flex align-center encuesta-dialog-title-wrap">
		          <v-icon color="primary" class="mr-2 flex-shrink-0">
		            mdi-clipboard-list-outline
		          </v-icon>
		          <span class="text-h6 font-weight-bold encuesta-dialog-main-title">Encuesta de Satisfacción</span>
		        </div>
		        <span class="encuesta-step-pill flex-shrink-0">{{ step }} de {{ totalPasos }}</span>
		      </div>

		      <v-alert
		        dense
		        text
		        color="primary"
		        border="left"
		        colored-border
		        class="mb-5 encuesta-satis-alert encuesta-dialog-intro"
		      >
		        Tu opinión es clave para nuestra mejora continua. Selecciona la opción que mejor represente tu experiencia en este ciclo.
		      </v-alert>

		      <template v-if="pasoActual">
		        <div class="encuesta-seccion-header mb-5">
		          <h2 class="titulo-seccion text-uppercase primary--text mb-1">{{ pasoActual.titulo }}</h2>
		          <p class="subtitulo-seccion mb-0">{{ pasoActual.subtitulo }}</p>
		        </div>

		        <div
		          v-for="(pregunta, j) in pasoActual.preguntas"
		          :key="'p-' + step + '-' + j"
		          :class="pregunta.tipo === 'texto' ? 'mb-5' : 'mb-4'"
		        >
		          <template v-if="pregunta.tipo === 'texto'">
		            <div class="encuesta-pregunta-card encuesta-pregunta-card--texto pa-4 rounded-xl">
		              <div v-if="pregunta.etiqueta" class="font-weight-bold text-body-2 mb-1 primary--text">{{ pregunta.etiqueta }}</div>
		              <p class="text-body-2 mb-3 encuesta-pregunta-desc primary--text font-weight-bold">{{ pregunta.texto }}</p>
		              <v-textarea
		                v-model="pregunta.respuesta"
		                outlined
		                rows="3"
		                auto-grow
		                hide-details="auto"
		                placeholder="Escribe aquí (opcional)"
		                color="primary"
		                class="mt-1"
		              />
		            </div>
		          </template>
		          <template v-else>
		            <div class="encuesta-pregunta-card pa-4 rounded-xl">
		              <div v-if="pregunta.etiqueta" class="font-weight-bold text-body-2 mb-1 primary--text">{{ pregunta.etiqueta }}</div>
		              <p class="text-body-2 mb-4 encuesta-pregunta-desc primary--text font-weight-bold">{{ pregunta.texto }}</p>
		              <ul
		                class="feedback encuesta-feedback-scale"
		              >
		                <li
		                  v-for="opt in escalaCaritas"
		                  :key="opt.valor"
		                  :class="`${opt.cls} ${ valorSeleccionado(pregunta, opt.valor) ? 'active' : '' }`"
		                  @click="setValor(pregunta, opt.valor)"
		                >
		                  <div>
		                    <svg class="eye left">
		                      <use xlink:href="#eye"></use>
		                    </svg>
		                    <svg class="eye right">
		                      <use xlink:href="#eye"></use>
		                    </svg>
		                    <svg v-if="opt.cls !== 'ok'" class="mouth">
		                      <use xlink:href="#mouth"></use>
		                    </svg>
		                  </div>
		                </li>
		              </ul>
		              <div class="escala-puntos-grid text-caption mt-2">
		                <span>0</span>
		                <span aria-hidden="true"></span>
		                <span aria-hidden="true"></span>
		                <span aria-hidden="true"></span>
		                <span>10</span>
		              </div>
		              <div class="escala-etiquetas-grid text-caption grey--text mt-1">
		                <span>Pésimo</span>
		                <span>Insuficiente</span>
		                <span>Regular</span>
		                <span>Bueno</span>
		                <span>Excelente</span>
		              </div>
		            </div>
		          </template>
		        </div>
		      </template>

		      <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
		        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4" id="eye">
		          <path d="M1,1 C1.83333333,2.16666667 2.66666667,2.75 3.5,2.75 C4.33333333,2.75 5.16666667,2.16666667 6,1"></path>
		        </symbol>
		        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 7" id="mouth">
		          <path d="M1,5.5 C3.66666667,2.5 6.33333333,1 9,1 C11.6666667,1 14.3333333,2.5 17,5.5"></path>
		        </symbol>
		      </svg>
		    </v-card-text>

		    <v-divider class="encuesta-dialog-divider"></v-divider>

		    <v-card-actions class="encuesta-dialog-actions pa-4 pt-4 flex-shrink-0">
		    	<v-btn
		      	v-if="step === 1"
		        text
		        class="encuesta-nav-secondary text-none"
		        @click="dialogEncuesta = false"
		        rounded
		      >
		        Cancelar
		      </v-btn>

		      <v-btn
		      	v-if="step > 1"
		        text
		        class="encuesta-nav-secondary text-none"
		        @click="step--"
		        rounded
		      >
		        Regresar
		      </v-btn>
		      <v-spacer></v-spacer>
		      <v-btn
		        v-if="step < totalPasos"
		        color="primary"
		        depressed
		        large
		        rounded
		        class="encuesta-nav-primary text-none font-weight-bold px-8"
		        @click="avanzarStep()"
		      >
		        Siguiente
		      </v-btn>

		      <v-btn
		        v-if="step === totalPasos && !bloquear"
		        color="primary"
		        depressed
		        large
		        rounded
		        class="encuesta-nav-primary text-none font-weight-bold px-8"
		        @click="save()"
		      >
		        Enviar
		      </v-btn>
		    </v-card-actions>
		  </v-card>
    </v-dialog>

    <Alerta   v-if="respuestaAlerta" :parametros="parametros"/>
		<Loader   v-if="cargar"          :loader="cargar"/>

	</div>
</template>
<script>
	import { mapGetters, mapActions } from 'vuex'
  const base64 = require('base-64');

  import  validarErrores from '@/mixins/validarErrores.js';

  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

	export default {
		components:{
  		Alerta,
  		Loader
  	},

		props:{
			encuestaSatis: {
				type: Object,
				default: null,
			},
			sinAvisoBloqueo: {
				type: Boolean,
				default: false,
			},
	  },

  	mixins:[validarErrores],


	  data: () => ({
	  	cargar: false,
			parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

     	respuestaAlerta:false,

	  	dialogEncuesta: false,
	  	step: 1,
	  	bloquear:false,
	  	pasos: [],
	  	escalaCaritas: [
	  	  { cls: 'angry', valor: 0 },
	  	  { cls: 'sad', valor: 2.5 },
	  	  { cls: 'ok', valor: 5 },
	  	  { cls: 'good', valor: 7.5 },
	  	  { cls: 'happy', valor: 10 },
	  	],
	  }),

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
      totalPasos () {
        return this.pasos.length
      },
      pasoActual () {
        return this.pasos[this.step - 1] || null
      },
      gruposParaEncuesta () {
        const gruposStore = Array.isArray(this.getGrupos)
          ? this.getGrupos.filter(Boolean)
          : []
        if (gruposStore.length) return gruposStore

        const gruposHabilitados = this.encuestaSatis && Array.isArray(this.encuestaSatis.grupos)
          ? this.encuestaSatis.grupos.filter(Boolean)
          : []
        return gruposHabilitados
      },
      mostrarAvisoGruposBloqueados () {
        if (this.sinAvisoBloqueo) return false
        return !(Array.isArray(this.getGrupos) && this.getGrupos.length)
      },
    },

    watch: {
      dialogEncuesta (abierta) {
        if (!abierta) {
          this.step = 1
          this.bloquear = false
        }
      },
    },

    created () {},

    methods:{
      ...mapActions( 'login', [ 'grabarGruposUsuario' ]),

    	async abrirEncuesta () {
    	  this.cargar = true
    	  try {
    	    await this.cargarPasosEncuesta()
    	    this.step = 1
    	    this.dialogEncuesta = true
    	  } catch (e) {
    	    console.error('Error abriendo encuesta:', e)
    	    const msg = (e && e.message) ? e.message : 'No se pudieron cargar las preguntas. Intenta de nuevo.'
    	    this.validarErrorDirecto(msg)
    	  } finally {
    	    this.cargar = false
    	  }
    	},

    	async cargarPasosEncuesta () {
    	  // IMPORTANTE: SIEMPRE intentamos obtener las preguntas desde el API porque
    	  // el guardado en BD requiere el `idencuesta_satisfaccion` de cada pregunta.
    	  // Si caemos al fallback local (sin ids), el backend no podrá vincular las
    	  // respuestas con el catálogo `encuesta_satisfaccion` y el POST regresará 500.
    	  let res
    	  try {
    	    res = await this.$http.get('encuestas.satisfaccion.preguntas.movil')
    	  } catch (e) {
    	    console.error('❌ Error cargando preguntas de encuesta:', e && e.status, e && e.body)
    	    throw new Error('No se pudieron cargar las preguntas de la encuesta. Verifica tu conexión e inténtalo de nuevo.')
    	  }

    	  const body = res ? res.body : null
    	  if (body && Array.isArray(body.pasos) && body.pasos.length) {
    	    const pasosNorm = this.normalizarPasosDesdeApi(body.pasos)
    	    const todasTienenId = pasosNorm.every((p) =>
    	      (p.preguntas || []).every((q) => q.idencuesta_satisfaccion != null)
    	    )
    	    if (!todasTienenId) {
    	      console.error('❌ El API devolvió preguntas sin idencuesta_satisfaccion:', pasosNorm)
    	      throw new Error('La encuesta no está bien configurada (faltan IDs de pregunta). Reporta este error al área de sistemas.')
    	    }
    	    this.pasos = pasosNorm
    	    return
    	  }

    	  throw new Error('No hay preguntas de encuesta configuradas en este momento. Inténtalo más tarde.')
    	},

    	normalizarPasosDesdeApi (pasos) {
    	  return pasos.map((paso) => ({
    	    titulo: paso.titulo,
    	    subtitulo: paso.subtitulo || '',
    	    preguntas: (paso.preguntas || []).map((p) => {
    	      const idencuesta_satisfaccion =
    	        p.idencuesta_satisfaccion != null ? Number(p.idencuesta_satisfaccion) : null
    	      if (p.tipo === 'texto') {
    	        return {
    	          tipo: 'texto',
    	          texto: p.texto,
    	          valor: null,
    	          respuesta: p.respuesta != null ? String(p.respuesta) : '',
    	          idencuesta_satisfaccion,
    	        }
    	      }
    	      return {
    	        texto: p.texto,
    	        valor: p.valor != null ? p.valor : null,
    	        id_teacher: p.id_teacher != null ? p.id_teacher : 0,
    	        idencuesta_satisfaccion,
    	      }
    	    }),
    	  }))
    	},

    	initialize () {
    		this.step = 1
    	},

    	buildPasos () {
        // Textos alineados a INBI–DRI–0014 (matriz de preguntas y definiciones de tema)
    	  return [
    	    {
    	      titulo: '1. ACADÉMICO',
    	      subtitulo: 'Progreso percibido, utilidad de contenidos y desempeño docente.',
    	      preguntas: [
    	        { texto: '¿Sientes que tu nivel de inglés ha mejorado en este curso?', valor: null },
    	        { texto: '¿Los temas vistos te resultan útiles para la vida real?', valor: null },
    	        { texto: '¿Tu profesor explica de forma clara y resuelve tus dudas?', valor: null },
    	        { texto: '¿Las clases te parecen dinámicas y participativas?', valor: null },
    	      ],
    	    },
    	    {
    	      titulo: '2. ATENCIÓN AL CLIENTE',
    	      subtitulo: 'Calidez, rapidez de respuesta y escucha activa del personal.',
    	      preguntas: [
    	        { texto: '¿La atención del personal es amable y profesional?', valor: null },
    	        { texto: '¿Tus dudas o trámites se resuelven de forma rápida?', valor: null },
    	        { texto: '¿Estás satisfecho con los canales de comunicación y atención que ofrece la escuela?', valor: null },
    	      ],
    	    },
    	    {
    	      titulo: '3. INSTALACIONES',
    	      subtitulo: 'Estado físico, limpieza y comodidad de los espacios.',
    	      preguntas: [
    	        { texto: '¿Los salones y áreas comunes están limpios y cuidados?', valor: null },
    	        { texto: '¿El mobiliario y equipo son adecuados para tus clases?', valor: null },
    	      ],
    	    },
    	    {
    	      titulo: '4. PLATAFORMA Y OPINIÓN',
    	      subtitulo: 'Estabilidad técnica y velocidad del sistema digital. Incluye una pregunta de opinión abierta opcional.',
    	      preguntas: [
    	        { texto: '¿La plataforma funciona rápido y sin errores técnicos?', valor: null },
    	        { tipo: 'texto', texto: '¿Hay algo más que te gustaría compartir sobre tu experiencia en la escuela?', respuesta: '' },
    	      ],
    	    },
    	  ]
    	},

    	valorSeleccionado (pregunta, valor) {
    	  return pregunta.valor !== null && pregunta.valor !== undefined && Number(pregunta.valor) === valor
    	},

    	setValor (pregunta, v) {
    	  this.$set(pregunta, 'valor', v)
    	},

    	pasoTieneTodasLasRespuestas (numPaso) {
    	  const paso = this.pasos[numPaso - 1]
    	  if (!paso) return false
    	  for (const p of paso.preguntas) {
    	    if (p.tipo === 'texto') continue
    	    if (p.valor === null || p.valor === undefined) return false
    	  }
    	  return true
    	},

    	buildCategoriasParaGuardar () {
        const categorias = []
        try {
          for (const paso of this.pasos) {
            const preguntas = []
            for (const p of paso.preguntas) {
              const textoBase = (p.texto || '').trim()
              const idencuesta_satisfaccion =
                p.idencuesta_satisfaccion != null ? Number(p.idencuesta_satisfaccion) : null
              if (p.tipo === 'texto') {
                const com = (p.respuesta || '').trim()
                preguntas.push({
                  idencuesta_satisfaccion,
                  pregunta: textoBase,
                  respuesta: com || null,
                  valor: 0,
                  id_teacher: p.id_teacher != null ? p.id_teacher : 0,
                })
              } else {
                preguntas.push({
                  idencuesta_satisfaccion,
                  pregunta: textoBase,
                  respuesta: null,
                  valor: p.valor != null ? p.valor : 0,
                  id_teacher: p.id_teacher != null ? p.id_teacher : 0,
                })
              }
            }
            categorias.push({
              categoria: paso.titulo.replace(/^\d+\.\s*/, '').trim(),
              preguntas,
            })
          }
        } catch (err) {
          console.error('Error construyendo categorías:', err)
          throw new Error('Error al procesar las respuestas de la encuesta')
        }
        return categorias
      },

      async refrescarGruposDespuesEncuesta () {
        if (!this.getUsuarioLMS || !this.getUsuarioLMS.id) return

        try {
          const idUsuario = base64.encode(this.getUsuarioLMS.id)
          const response = await this.$http.get('grupos.alumno/' + idUsuario)
          this.grabarGruposUsuario(response.body || [])
        } catch (error) {
          console.error('Error actualizando grupos después de encuesta:', error)
        }
      },

      save () {
        if (!this.pasoTieneTodasLasRespuestas(this.step)) {
          this.validarErrorDirecto('Responde la pregunta de plataforma antes de enviar.')
          return
        }
        if (this.encuestaSatis && this.encuestaSatis.sinGrupo) {
          this.validarErrorDirecto('Cuando tengas un grupo en «Mis grupos» podrás enviar la encuesta. Puedes usar el botón de actualizar arriba a la derecha.')
          return
        }
        // Validar datos requeridos
        if (!this.getUsuarioLMS || !this.getUsuarioLMS.iderp || !this.getUsuarioLMS.id) {
          this.validarErrorDirecto('Datos de usuario incompletos. Por favor, inicia sesión de nuevo.')
          return
        }

        // Validar que TODAS las preguntas (no de tipo texto) tengan idencuesta_satisfaccion;
        // sin este id el backend no puede vincular la respuesta con la tabla `encuesta_satisfaccion`.
        const faltanIds = this.pasos.some((p) =>
          (p.preguntas || []).some((q) =>
            q.tipo !== 'texto' && (q.idencuesta_satisfaccion == null)
          )
        )
        if (faltanIds) {
          this.validarErrorDirecto('No se pudieron cargar correctamente las preguntas. Cierra la encuesta y vuelve a abrirla.')
          return
        }
        
        this.cargar = true
      	this.bloquear = true

        // Los grupos pueden venir vacíos porque el backend los oculta mientras la encuesta está pendiente.
        const listaGrupos = this.gruposParaEncuesta

        // Extraer solo los IDs de los grupos cuando sí estén cargados.
        const gruposIds = listaGrupos.map(g => g.id || g).filter(id => id)

        const ciclosIds = [...new Set(
          listaGrupos
            .map((g) => (g && typeof g === 'object' ? g.id_ciclo : null))
            .filter((id) => id != null && id !== '')
        )]

        // Misma regla que api-movil `addEncuestaSatisfaccion`: con varios grupos se usa el último (nivel más alto).
        // El id_ciclo debe ser el de ese grupo; si se tomaba solo el primero, la ventana del ciclo podía no coincidir y el API rechazaba el guardado.
        const grupoEncuestaRef =
          listaGrupos.length > 1 ? listaGrupos[listaGrupos.length - 1] : listaGrupos[0]
        const idCiclo =
          grupoEncuestaRef && typeof grupoEncuestaRef === 'object'
            ? (grupoEncuestaRef.id_ciclo != null && grupoEncuestaRef.id_ciclo !== ''
              ? grupoEncuestaRef.id_ciclo
              : null)
            : null

        const categorias = this.buildCategoriasParaGuardar()

      	const payload = {
      		id_alumno: this.getUsuarioLMS.iderp,
      		id_usuario_lms: this.getUsuarioLMS.id,
      		escuela: this.getEscuela,
      		id_ciclo: idCiclo,
      		grupos: gruposIds,
      		categorias,
      	}

      	if (process.env.NODE_ENV === 'development') {
      	  console.log('📋 Categorías construidas:', JSON.stringify(categorias, null, 2))
      	  console.log('📋 Grupos enviados:', gruposIds)
      	  console.log('📋 Ciclos enviados:', ciclosIds)
      	  console.log('📤 Enviando encuesta:', JSON.stringify(payload, null, 2))
      	}

      	this.$http.post('encuestas.satisfaccion', payload ).then( response => {
      		// Manejo correcto de respuesta en vue-resource
      		const mensaje = response.body && response.body.message ? response.body.message : 'Encuesta enviada correctamente'
      		console.log('✅ Respuesta servidor:', response.body)
      		this.validarSuccess(mensaje)
      		const me = this
      		setTimeout(function(){ 
      			me.cargar = false
      			me.bloquear = false
      			if (me.encuestaSatis) {
      				me.encuestaSatis.visible = false
      			}
      			me.dialogEncuesta = false
            me.refrescarGruposDespuesEncuesta()
      		}, 2000)
        }).catch( error => {
        	this.cargar = false
        	this.bloquear = false
        	
        	// Log detallado del error para debugging
        	console.error('❌ Error al guardar encuesta:', {
        	  status: error.status,
        	  statusText: error.statusText,
        	  body: error.body,
        	  bodyJSON: JSON.stringify(error.body),
        	  message: error.message,
        	  fullError: error
        	})
        	
        	// Extraer el mensaje de error de diferentes formatos posibles
        	try {
        	  let mensajeError = 'Error al guardar la encuesta. Intenta de nuevo.'
        	  
        	  // Prioridad de búsqueda del mensaje de error
        	  if (error && typeof error === 'object') {
        	    // Intentar obtener desde body.message (más común en servidores bien configurados)
        	    if (error.body?.message) {
        	      mensajeError = error.body.message
        	    } 
        	    // Intentar obtener desde body.error
        	    else if (error.body?.error) {
        	      mensajeError = error.body.error
        	    }
        	    // Intentar obtener desde body.msg
        	    else if (error.body?.msg) {
        	      mensajeError = error.body.msg
        	    }
        	    // Intentar obtener desde body (si es string directo)
        	    else if (typeof error.body === 'string' && error.body.trim()) {
        	      mensajeError = error.body
        	    }
        	    // Si el body es un objeto pero vacío y es 500, ser específico
        	    else if (error.status === 500 && (!error.body || Object.keys(error.body).length === 0)) {
        	      mensajeError = 'Error interno del servidor. Revisa los logs del backend para más detalles.'
        	    }
        	    // Intentar message directo
        	    else if (error.message) {
        	      mensajeError = error.message
        	    } 
        	    // Intentar statusText
        	    else if (error.statusText) {
        	      mensajeError = error.statusText
        	    }
        	  } else if (typeof error === 'string') {
        	    mensajeError = error
        	  }
        	  
        	  this.validarError({
        	    status: error.status || 500,
        	    body: { message: mensajeError }
        	  })
        	} catch (e) {
        	  console.error('Error en catch block:', e, error)
        	  this.validarErrorDirecto('Error al guardar la encuesta. Por favor, intenta de nuevo.')
        	}
        })
      },

      avanzarStep () {
        if (!this.pasoTieneTodasLasRespuestas(this.step)) {
          this.validarErrorDirecto('Por favor responde todas las preguntas de esta sección antes de continuar.')
          return
        }
    		this.step += 1
      },
    }
  }
</script>



<style scoped>
  .encuesta-teaser-card {
    border: 1px solid rgba(25, 118, 210, 0.12) !important;
    background: linear-gradient(145deg, #fbfdff 0%, #f0f6ff 42%, #ffffff 100%) !important;
    box-shadow:
      0 4px 6px -1px rgba(25, 118, 210, 0.06),
      0 12px 40px -8px rgba(25, 118, 210, 0.12) !important;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
  }

  .encuesta-teaser-card:hover {
    box-shadow:
      0 8px 16px -4px rgba(25, 118, 210, 0.1),
      0 20px 48px -12px rgba(25, 118, 210, 0.14) !important;
  }

  .encuesta-teaser-card--warning {
    border-color: rgba(251, 140, 0, 0.28) !important;
    background: linear-gradient(145deg, #fffdf7 0%, #fff8e1 42%, #ffffff 100%) !important;
    box-shadow:
      0 4px 6px -1px rgba(251, 140, 0, 0.06),
      0 12px 40px -8px rgba(251, 140, 0, 0.12) !important;
  }

  .encuesta-teaser-card--warning:hover {
    box-shadow:
      0 8px 16px -4px rgba(251, 140, 0, 0.1),
      0 20px 48px -12px rgba(251, 140, 0, 0.14) !important;
  }

  .encuesta-teaser-inner {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 20px 20px 18px;
  }

  .encuesta-teaser-icon-wrap {
    flex-shrink: 0;
    width: 56px;
    height: 56px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(25, 118, 210, 0.1);
    border: 1px solid rgba(25, 118, 210, 0.15);
  }

  .encuesta-teaser-icon-wrap--warning {
    background: rgba(251, 140, 0, 0.1);
    border-color: rgba(251, 140, 0, 0.2);
  }

  .encuesta-teaser-icon--warning {
    color: #fb8c00 !important;
  }

  .encuesta-teaser-overline--warning {
    color: rgba(251, 140, 0, 0.85) !important;
  }

  .encuesta-teaser-title--warning {
    color: #e65100 !important;
  }

  .encuesta-teaser-copy {
    flex: 1;
    min-width: 0;
    text-align: left;
  }

  .encuesta-teaser-overline {
    display: block;
    color: rgba(0, 0, 0, 0.45) !important;
    font-weight: 600;
    margin-bottom: 4px;
  }

  .encuesta-teaser-title {
    line-height: 1.3;
    letter-spacing: -0.01em;
  }

  .encuesta-teaser-desc {
    color: rgba(0, 0, 0, 0.58);
    line-height: 1.45;
    margin-bottom: 0;
  }

  .encuesta-teaser-cta {
    letter-spacing: 0.02em;
  }

  .letter-spacing-1 {
    letter-spacing: 0.08em !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar-button:increment,.v-dialog__content.v-dialog__content--active::-webkit-scrollbar-button{
    display: none;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }


  .encuesta-satis-dialog {
    background: linear-gradient(160deg, #fbfdff 0%, #f0f6ff 38%, #ffffff 100%) !important;
    box-shadow: none !important;
  }

  .encuesta-dialog-body {
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
  }

  .encuesta-dialog-title-wrap {
    min-width: 0;
  }

  .encuesta-dialog-main-title {
    letter-spacing: -0.02em;
    line-height: 1.25;
  }

  .encuesta-step-pill {
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    padding: 6px 14px;
    border-radius: 999px;
    background: rgba(25, 118, 210, 0.1);
    color: #1565c0;
    border: 1px solid rgba(25, 118, 210, 0.2);
  }

  .encuesta-satis-alert {
    border-radius: 12px !important;
  }

  .encuesta-dialog-intro {
    background: rgba(25, 118, 210, 0.06) !important;
    border-left-width: 4px !important;
  }

  .encuesta-seccion-header {
    padding-bottom: 2px;
    border-bottom: 1px solid rgba(25, 118, 210, 0.12);
  }

  .encuesta-pregunta-card {
    background: #ffffff;
    border: 1px solid rgba(25, 118, 210, 0.1);
    box-shadow:
      0 2px 4px rgba(25, 118, 210, 0.04),
      0 8px 24px rgba(0, 0, 0, 0.04);
  }

  .encuesta-pregunta-card--texto {
    background: linear-gradient(180deg, #ffffff 0%, #fafcfe 100%);
  }

  .encuesta-pregunta-desc {
    color: rgba(0, 0, 0, 0.65);
    line-height: 1.45;
  }

  .escala-puntos-grid,
  .escala-etiquetas-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    align-items: start;
    gap: 2px 4px;
    text-align: center;
    width: 100%;
  }

  .escala-puntos-grid span {
    font-weight: 600;
    color: rgba(0, 0, 0, 0.38);
  }

  .escala-etiquetas-grid span {
    font-size: 0.65rem;
    line-height: 1.2;
    hyphens: auto;
    word-break: break-word;
  }

  @media (min-width: 400px) {
    .escala-etiquetas-grid span {
      font-size: 0.7rem;
    }
  }

  .encuesta-dialog-divider {
    border-color: rgba(25, 118, 210, 0.08) !important;
  }

  .encuesta-dialog-actions {
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border-top: 1px solid rgba(0, 0, 0, 0.06) !important;
    align-items: center !important;
  }

  .encuesta-nav-secondary.v-btn {
    font-weight: 600;
    letter-spacing: 0.04em;
    color: rgba(0, 0, 0, 0.62) !important;
  }

  .encuesta-nav-primary.v-btn {
    min-height: 48px !important;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.28) !important;
  }

  .titulo-seccion {
    font-size: 1.15rem;
    font-weight: 800;
    letter-spacing: 0.02em;
    margin-bottom: 4px;
  }

  .subtitulo-seccion {
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.6);
    line-height: 1.35;
  }

  .encuesta-feedback-scale.feedback {
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px 4px;
  }

  .encuesta-feedback-scale.feedback li:not(:last-child) {
    margin-right: 6px;
  }

  .encuesta-feedback-scale.feedback li div {
    width: 36px;
    height: 36px;
  }

  @media (min-width: 360px) {
    .encuesta-feedback-scale.feedback li:not(:last-child) {
      margin-right: 12px;
    }
    .encuesta-feedback-scale.feedback li div {
      width: 40px;
      height: 40px;
    }
  }

  .feedback {
    --normal: #ECEAF3;
    --normal-shadow: #D9D8E3;
    --normal-mouth: #9795A4;
    --normal-eye: #595861;
    --active: #F8DA69;
    --active-shadow: #F4B555;
    --active-mouth: #F05136;
    --active-eye: #313036;
    --active-tear: #76b5e7;
    --active-shadow-angry: #e94f1d;
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
  }
  .feedback li {
    position: relative;
    border-radius: 50%;
    background: var(--sb, var(--normal));
    box-shadow: inset 3px -3px 4px var(--sh, var(--normal-shadow));
    transition: background 0.4s, box-shadow 0.4s, transform 0.3s;
    -webkit-tap-highlight-color: transparent;
  }
  .feedback li:not(:last-child) {
    margin-right: 20px;
  }
  .feedback li div {
    width: 40px;
    height: 40px;
    position: relative;
    transform: perspective(240px) translateZ(4px);
  }
  .feedback li div svg, .feedback li div:before, .feedback li div:after {
    display: block;
    position: absolute;
    left: var(--l, 9px);
    top: var(--t, 13px);
    width: var(--w, 8px);
    height: var(--h, 2px);
    transform: rotate(var(--r, 0deg)) scale(var(--sc, 1)) translateZ(0);
  }
  .feedback li div svg {
    fill: none;
    stroke: var(--s);
    stroke-width: 2px;
    stroke-linecap: round;
    stroke-linejoin: round;
    transition: stroke 0.4s;
  }
  .feedback li div svg.eye {
    --s: var(--e, var(--normal-eye));
    --t: 17px;
    --w: 7px;
    --h: 4px;
  }
  .feedback li div svg.eye.right {
    --l: 23px;
  }
  .feedback li div svg.mouth {
    --s: var(--m, var(--normal-mouth));
    --l: 11px;
    --t: 23px;
    --w: 18px;
    --h: 7px;
  }
  .feedback li div:before, .feedback li div:after {
    content: "";
    z-index: var(--zi, 1);
    border-radius: var(--br, 1px);
    background: var(--b, var(--e, var(--normal-eye)));
    transition: background 0.4s;
  }
  .feedback li.angry {
    --step-1-rx: -24deg;
    --step-1-ry: 20deg;
    --step-2-rx: -24deg;
    --step-2-ry: -20deg;
  }
  .feedback li.angry div:before {
    --r: 20deg;
  }
  .feedback li.angry div:after {
    --l: 23px;
    --r: -20deg;
  }
  .feedback li.angry div svg.eye {
    stroke-dasharray: 4.55;
    stroke-dashoffset: 8.15;
  }
  .feedback li.angry.active {
    -webkit-animation: angry 1s linear;
            animation: angry 1s linear;
  }
  .feedback li.angry.active div:before {
    --middle-y: -2px;
    --middle-r: 22deg;
    -webkit-animation: toggle 0.8s linear forwards;
            animation: toggle 0.8s linear forwards;
  }
  .feedback li.angry.active div:after {
    --middle-y: 1px;
    --middle-r: -18deg;
    -webkit-animation: toggle 0.8s linear forwards;
            animation: toggle 0.8s linear forwards;
  }
  .feedback li.sad {
    --step-1-rx: 20deg;
    --step-1-ry: -12deg;
    --step-2-rx: -18deg;
    --step-2-ry: 14deg;
  }
  .feedback li.sad div:before, .feedback li.sad div:after {
    --b: var(--active-tear);
    --sc: 0;
    --w: 5px;
    --h: 5px;
    --t: 15px;
    --br: 50%;
  }
  .feedback li.sad div:after {
    --l: 25px;
  }
  .feedback li.sad div svg.eye {
    --t: 16px;
  }
  .feedback li.sad div svg.mouth {
    --t: 24px;
    stroke-dasharray: 9.5;
    stroke-dashoffset: 33.25;
  }
  .feedback li.sad.active div:before, .feedback li.sad.active div:after {
    -webkit-animation: tear 0.6s linear forwards;
            animation: tear 0.6s linear forwards;
  }
  .feedback li.ok {
    --step-1-rx: 4deg;
    --step-1-ry: -22deg;
    --step-1-rz: 6deg;
    --step-2-rx: 4deg;
    --step-2-ry: 22deg;
    --step-2-rz: -6deg;
  }
  .feedback li.ok div:before {
    --l: 12px;
    --t: 17px;
    --h: 4px;
    --w: 4px;
    --br: 50%;
    box-shadow: 12px 0 0 var(--e, var(--normal-eye));
  }
  .feedback li.ok div:after {
    --l: 13px;
    --t: 26px;
    --w: 14px;
    --h: 2px;
    --br: 1px;
    --b: var(--m, var(--normal-mouth));
  }
  .feedback li.ok.active div:before {
    --middle-s-y: .35;
    -webkit-animation: toggle 0.2s linear forwards;
            animation: toggle 0.2s linear forwards;
  }
  .feedback li.ok.active div:after {
    --middle-s-x: .5;
    -webkit-animation: toggle 0.7s linear forwards;
            animation: toggle 0.7s linear forwards;
  }
  .feedback li.good {
    --step-1-rx: -14deg;
    --step-1-rz: 10deg;
    --step-2-rx: 10deg;
    --step-2-rz: -8deg;
  }
  .feedback li.good div:before {
    --b: var(--m, var(--normal-mouth));
    --w: 5px;
    --h: 5px;
    --br: 50%;
    --t: 22px;
    --zi: 0;
    opacity: 0.5;
    box-shadow: 16px 0 0 var(--b);
    filter: blur(2px);
  }
  .feedback li.good div:after {
    --sc: 0;
  }
  .feedback li.good div svg.eye {
    --t: 15px;
    --sc: -1;
    stroke-dasharray: 4.55;
    stroke-dashoffset: 8.15;
  }
  .feedback li.good div svg.mouth {
    --t: 22px;
    --sc: -1;
    stroke-dasharray: 13.3;
    stroke-dashoffset: 23.75;
  }
  .feedback li.good.active div svg.mouth {
    --middle-y: 1px;
    --middle-s: -1;
    -webkit-animation: toggle 0.8s linear forwards;
            animation: toggle 0.8s linear forwards;
  }
  .feedback li.happy div {
    --step-1-rx: 18deg;
    --step-1-ry: 24deg;
    --step-2-rx: 18deg;
    --step-2-ry: -24deg;
  }
  .feedback li.happy div:before {
    --sc: 0;
  }
  .feedback li.happy div:after {
    --b: var(--m, var(--normal-mouth));
    --l: 11px;
    --t: 23px;
    --w: 18px;
    --h: 8px;
    --br: 0 0 8px 8px;
  }
  .feedback li.happy div svg.eye {
    --t: 14px;
    --sc: -1;
  }
  .feedback li.happy.active div:after {
    --middle-s-x: .95;
    --middle-s-y: .75;
    -webkit-animation: toggle 0.8s linear forwards;
            animation: toggle 0.8s linear forwards;
  }

  .feedback li:not(.active) {
    cursor: pointer;
  }

  .feedback li:not(.active):active {
    transform: scale(0.925);
  }
  .feedback li.active {
    --sb: var(--active);
    --sh: var(--active-shadow);
    --m: var(--active-mouth);
    --e: var(--active-eye);
  }
  .feedback li.active div {
    -webkit-animation: shake 0.8s linear forwards;
            animation: shake 0.8s linear forwards;
  }

  @keyframes shake {
    30% {
      transform: perspective(240px) rotateX(var(--step-1-rx, 0deg)) rotateY(var(--step-1-ry, 0deg)) rotateZ(var(--step-1-rz, 0deg)) translateZ(10px);
    }
    60% {
      transform: perspective(240px) rotateX(var(--step-2-rx, 0deg)) rotateY(var(--step-2-ry, 0deg)) rotateZ(var(--step-2-rz, 0deg)) translateZ(10px);
    }
    100% {
      transform: perspective(240px) translateZ(4px);
    }
  }
  @-webkit-keyframes tear {
    0% {
      opacity: 0;
      transform: translateY(-2px) scale(0) translateZ(0);
    }
    50% {
      transform: translateY(12px) scale(0.6, 1.2) translateZ(0);
    }
    20%, 80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(24px) translateX(4px) rotateZ(-30deg) scale(0.7, 1.1) translateZ(0);
    }
  }
  @keyframes tear {
    0% {
      opacity: 0;
      transform: translateY(-2px) scale(0) translateZ(0);
    }
    50% {
      transform: translateY(12px) scale(0.6, 1.2) translateZ(0);
    }
    20%, 80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(24px) translateX(4px) rotateZ(-30deg) scale(0.7, 1.1) translateZ(0);
    }
  }
  @-webkit-keyframes toggle {
    50% {
      transform: translateY(var(--middle-y, 0)) scale(var(--middle-s-x, var(--middle-s, 1)), var(--middle-s-y, var(--middle-s, 1))) rotate(var(--middle-r, 0deg));
    }
  }
  @keyframes toggle {
    50% {
      transform: translateY(var(--middle-y, 0)) scale(var(--middle-s-x, var(--middle-s, 1)), var(--middle-s-y, var(--middle-s, 1))) rotate(var(--middle-r, 0deg));
    }
  }
  @-webkit-keyframes angry {
    40% {
      background: var(--active);
    }
    45% {
      box-shadow: inset 3px -3px 4px var(--active-shadow), inset 0 8px 10px var(--active-shadow-angry);
    }
  }
  @keyframes angry {
    40% {
      background: var(--active);
    }
    45% {
      box-shadow: inset 3px -3px 4px var(--active-shadow), inset 0 8px 10px var(--active-shadow-angry);
    }
  }

  html {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
  }

  * {
    box-sizing: inherit;
  }
  *:before, *:after {
    box-sizing: inherit;
  }

  #modalCokie {
    z-index: 1;
    position: fixed;
    top: 0px;
    left: 0px;
    overflow-x: hidden;
    display: block;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-pack: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 250000ms 700000ms;
    overflow-x: hidden;
    background-color: rgba(31,32,41,.75);
    align-items: center;
  }

  .encuesta2 {
    z-index: 1;
    position: fixed;
    top: 0px;
    left: 0px;
    overflow-x: hidden;
    display: block;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-pack: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 250000ms 700000ms;
    overflow-x: hidden;
    background-color: rgba(31,32,41,.75);
    align-items: center;
  }

  .cookiesContent {
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    color: #000;
    text-align: center;
    border-radius: 20px;
    padding: 30px 30px 70px;
  }

  .cookiesContent button.close {
    width: 30px;
    font-size: 20px;
    color: #c0c5cb;
    align-self: flex-end;
    background-color: transparent;
    border: none;
    margin-bottom: 10px;
  }

  .cookiesContent img {
    width: 250px;
    margin-bottom: 15px;
  }

  .cookiesContent p {
    margin-bottom: 40px;
    font-size: 18px;
  }

  .cookiesContent button.accept {
    background-color: #ed6755;
    border: none;
    border-radius: 5px;
    width: 200px;
    padding: 14px;
    font-size: 16px;
    color: white;
    box-shadow: 0px 6px 18px -5px #ed6755;
  }

  @media only screen and (max-width: 1026px) {
      #fadeshow1 {
          display: none;
      }
  }

  #page-top {
    padding-right: 0px;
  }

  .progress {
    width: 150px;
    height: 150px;
    background: none;
    position: relative;
  }

  .progress::after {
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 22px solid #eee;
    position: absolute;
    top: 0;
    left: 0;
  }

  .progress>span {
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1;
  }

  .progress .progress-left {
    left: 0;
  }

  .progress .progress-bar {
    width: 100%;
    height: 100%;
    background: none;
    border-width: 22px;
    border-style: solid;
    position: absolute;
    top: 0;
  }

  .progress .progress-left .progress-bar {
    left: 100%;
    border-top-right-radius: 80px;
    border-bottom-right-radius: 80px;
    border-left: 0;
    -webkit-transform-origin: center left;
    transform-origin: center left;
  }

  .progress .progress-right {
    right: 0;
  }

  .progress .progress-right .progress-bar {
    left: -100%;
    border-top-left-radius: 80px;
    border-bottom-left-radius: 80px;
    border-right: 0;
    -webkit-transform-origin: center right;
    transform-origin: center right;
  }

  .progress .progress-value {
    position: absolute;
    top: 0;
    left: 0;
  }

  /*******************************************************************/
  #card-grupo {
    background: rgb(0, 0, 99);
    background: linear-gradient(90deg, rgba(0, 0, 99, 0.8519782913165266) 9%, rgba(9, 75, 121, 0.8407738095238095) 44%, rgba(185, 242, 255, 1) 100%);
    color: #FFF !important;
  }

  /******************************************************************/
  #chartdiv {
    width: 100%;
    height: 130px;
  }

  /*
  *
  * ==========================================
  * FOR DEMO PURPOSE
  * ==========================================
  *
  */

  body {
    background: #ff7e5f;
    background: -webkit-linear-gradient(to right, #ff7e5f, #feb47b);
    background: linear-gradient(to right, #ff7e5f, #feb47b);
    min-height: 100vh;
    padding-right: 0px !important;
  }

  .rounded-lg {
    border-radius: 1rem;
  }

  .text-gray {
    color: #aaa;
  }

  div.h4 {
    line-height: 1rem;
  }

  .scroll {
    overflow-y: hidden;
  }
</style>